import {take, put} from 'redux-saga/effects';
import {openModal, closeModal} from '@computerrock/formation-router/sagas';
import modalIds from '../../modalIds';
import * as serviceCaseActionTypes from '../../service-cases/serviceCaseActionTypes';

/**
 * Initiate empty case creation flow
 */
const initiateEmptyCaseCreationFlow = function* initiateEmptyCaseCreationFlow() {
    while (true) {
        yield take([serviceCaseActionTypes.INITIATE_EMPTY_CASE_CREATION_FLOW]);

        yield* openModal(modalIds.CREATE_EMPTY_CASE);
        const chosenModalOption = yield take([
            serviceCaseActionTypes.DECLINE_CREATE_EMPTY_CASE,
            serviceCaseActionTypes.CONFIRM_CREATE_EMPTY_CASE,
        ]);

        if (chosenModalOption
            && chosenModalOption.type === serviceCaseActionTypes.CONFIRM_CREATE_EMPTY_CASE) {
            const {payload: modalOptionPayload} = chosenModalOption;
            yield put({
                type: serviceCaseActionTypes.CREATE_SERVICE_CASE,
                payload: {
                    ...modalOptionPayload,
                },
            });
        }

        yield* closeModal(modalIds.CREATE_EMPTY_CASE);
    }
};

export default initiateEmptyCaseCreationFlow;
